import React from 'react';

const ErrorMessage = () => {
	return <h1>No images found</h1>;
};

export default ErrorMessage;
